import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { DivisionWithCourses } from '@/lib/types';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export function useGetDivisions() {
	return useQuery<DivisionWithCourses[]>({
		queryKey: ['get-all-divisions', schoolId],

		queryFn: async () => {
			const { data, error } = await supabase
				.from('divisions')
				.select(
					`
					id,
					name,
					courses_divisions (
						courses_divisions_id,
						course_id,
						division_id
					)
				`
				)
				.eq('school_id', schoolId)
				.order('name', { ascending: true });

			if (error) throw error;

			return (data ?? []) as unknown as DivisionWithCourses[];
		},

		staleTime: Infinity,
		refetchOnMount: false,
	});
}
